export default __webpack_public_path__ + "static/media/Group1179.d3c0f2ee.svg";